interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export default function Input({ label, error, className = '', ...props }: InputProps) {
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label className="text-xs text-muted uppercase tracking-wide">{label}</label>
      )}
      <input
        className={`bg-surface border border-border rounded px-4 py-2.5 text-foreground placeholder:text-muted/50 focus:outline-none focus:border-primary transition-colors ${className}`}
        {...props}
      />
      {error && <span className="text-xs text-danger">{error}</span>}
    </div>
  );
}
